<template>
  <generic-view :prepend="url" :steps="steps" not-numbered :loading="loading">
    <estime v-if="sas" :sasId="sas.id"></estime>
    <introduction
      v-show="step == 'introduction'"
      endpoint="demande-reinscription-psychologue"
      @next-step="next"
    ></introduction>
    <template v-if="sas">
      <div v-for="s in realSteps" :key="s.path">
        <div v-show="step == s.path">
          <headline :code="s.code"></headline>
          <component :is="s.path" :sas="sas" @validation-changed="setState(s.path, $event)" :ref="s.path">
            <ressource :code="s.code" />
          </component>
          <v-btn color="#3a3838" dark class="mt-6" x-large @click="next">Enregistrer et continuer</v-btn>
        </div>
      </div>
      <soumission-avec-engagement
        v-show="step == 'soumission'"
        :showAlert="formulaireNonValide"
        @submit="submit"
        ref="soumission"
      ></soumission-avec-engagement>
    </template>
  </generic-view>
</template>

<script>
import Introduction from "@/components/FormParts/Introduction"
import CategorieMembre from "@/components/DemandeInscriptionPsychologue/CategorieMembre"
import Identification from "@/components/DemandeInscriptionPsychologue/Identification"
import RenseignementsProfessionnels from "@/components/DemandeInscriptionPsychologue/RenseignementsProfessionnels"
import MembreAutreOrdre from "@/components/DemandeInscriptionPsychologue/MembreAutreOrdre"
import CoordonneesProfessionnelles from "@/components/DemandeInscriptionPsychologue/CoordonneesProfessionnelles"
import ServicesReference from "@/components/FormParts/ServicesReference"
import Consentements from "@/components/DemandeInscriptionPsychologue/Consentements"
import DeclarationsJudiciaires from "@/components/FormParts/DeclarationsJudiciaires"
import EstimationFrais from "@/components/DemandeInscriptionPsychologue/EstimationFrais"
import SoumissionAvecEngagement from "@/components/FormParts/SoumissionAvecEngagement"
import Estime from "@/components/FormParts/Estime"
import FormulaireViewBase from "@/mixins/FormulaireViewBase"
import FormulaireBase from "@/mixins/FormulaireBase"
import RegroupementsDeTravail from "@/components/FormParts/RegroupementsDeTravail.vue"

export default {
  mixins: [FormulaireViewBase, FormulaireBase],

  data() {
    return {
      url: "/demande-reinscription-psychologue/",
      paramsName: "reinscription-psychologue",
      loadPanierOnLoad: true,
      steps: [
        { path: "introduction", code: "titre-introduction", state: "" },
        { path: "categorie-membre", code: "titre-etape-1", state: "" },
        { path: "identification", code: "titre-etape-2", state: "" },
        { path: "renseignements-professionnels", code: "titre-etape-3", state: "" },
        { path: "membre-autre-ordre", code: "titre-etape-4", state: "" },
        { path: "coordonnees-professionnelles", code: "titre-etape-5", state: "" },
        { path: "regroupements-de-travail", code: "titre-etape-11", state: "" },
        { path: "services-reference", code: "titre-etape-6", state: "" },
        { path: "consentements", code: "titre-etape-7", state: "" },
        { path: "declarations-judiciaires", code: "titre-etape-8", state: "" },
        { path: "estimation-frais", code: "titre-etape-9", state: "" },
        { path: "soumission", code: "titre-soumission" },
      ],
    }
  },

  components: {
    Introduction,
    CategorieMembre,
    Identification,
    RenseignementsProfessionnels,
    MembreAutreOrdre,
    CoordonneesProfessionnelles,
    RegroupementsDeTravail,
    ServicesReference,
    Consentements,
    DeclarationsJudiciaires,
    EstimationFrais,
    SoumissionAvecEngagement,
    Estime,
  },

  metaInfo() {
    return {
      title: this.$i18n.t("meta.formulaires.title"),
    }
  },
}
</script>

<style></style>
